module.exports = __webpack_public_path__ + "static/media/pla_green_gaint_straw3.bc911120.png";